export class Params {
    dealerGroupId: number = 0;
    month: number = 0;
    year: number = 0;
    quarter: number = 0;
    constructor(dealerGroupId: number, month: number, year: number, quarter: number) {
        this.dealerGroupId = dealerGroupId;
        this.month = month;
        this.year = year;
        this.quarter = quarter;
    }
    public updateData(viewType:string,dealerGroupId: number, month: number, year: number, quarter: number) {
        if (viewType === "daysOfMonth") {
            this.dealerGroupId = dealerGroupId;
            this.month = month;
            this.year = year;
            this.quarter = 0;
          } else if (viewType === "monthsOfYear") {
            this.dealerGroupId = dealerGroupId;
            this.month = 0;
            this.year = year;
            this.quarter = 0;
          } else if (viewType === "monthsOfQuarter") {
            this.dealerGroupId = dealerGroupId;
            this.month = 0;
            this.year = year;
            this.quarter = quarter;
          }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/budget/class/params.ts